import { writable } from "svelte/store";
import { LAST_ADDRESS, FIRST_ADDRESS, isValidAddress } from "../util/ram";
import { WORD_SIZE } from "../util/cpu";
let selection = {
    address: null,
    column: "CELL"
};
const { subscribe, set, update } = writable(selection);
// updates the store and keeps the local value in sync
function setSync(value) {
    set(value);
    selection = value;
}
// updates the store and keeps the local value in sync
function updateSync(updater) {
    update(updater);
    selection = updater(selection);
}
function selectDown() {
    updateSync(previous => {
        let tmp = (previous.address += WORD_SIZE);
        return Object.assign(Object.assign({}, previous), { address: tmp > LAST_ADDRESS ? LAST_ADDRESS : tmp });
    });
}
function selectUp() {
    updateSync(previous => {
        let tmp = (previous.address -= WORD_SIZE);
        return Object.assign(Object.assign({}, previous), { address: tmp < FIRST_ADDRESS ? FIRST_ADDRESS : tmp });
    });
}
function selectLeft() {
    updateSync(previous => (Object.assign(Object.assign({}, previous), { column: "LABEL" })));
}
function selectRight() {
    updateSync(previous => (Object.assign(Object.assign({}, previous), { column: "CELL" })));
}
function select(address, column = "CELL") {
    if (!isValidAddress(address))
        throw new Error("Invalid address");
    updateSync(previous => (Object.assign(Object.assign({}, previous), { address,
        column })));
}
function deselect() {
    updateSync(previous => (Object.assign(Object.assign({}, previous), { address: null })));
}
function noSelection() {
    return selection.address === null;
}
function isSelected(address, column) {
    return selection.address === address && selection.column === column;
}
export default {
    subscribe,
    selectUp,
    selectDown,
    selectLeft,
    selectRight,
    select,
    deselect,
    noSelection,
    isSelected
};
